module.exports = __webpack_public_path__ + "img/caro3.be304707.png";